// import { Button, message, Switch, Table, Upload } from "antd";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import AppInput from "../../../components/AppInput";
// import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
// import { post } from "../../../services/services";
// import { ApiURL } from "../../../services/apiConstants";
// import SelectInput from "../../../components/SelectInput";
// import VoyageDetails from "../../../components/VoyageDetails";
// import useUserData from "../../../hooks/useUserData";
// import { UploadOutlined } from "@ant-design/icons";
// import useDocumentUpload from "../../../hooks/useDocumentUpload";
// import TextArea from "antd/es/input/TextArea";
// import RequestFormModal from "../../../components/RequestFormModal.js";
// import SecurityCodeModal from "../../../components/SecurityCodeModal.js";
// import EditOilRecordLogPartOneModal from "./components/IcodeEditEntry.js";
// import { formatDate } from "../../../utils/dateFormatter.js";
// import ConfirmationModal from "../../../components/ConfirmationDialog.js";

// function EditOilRecordLogOne() {
//   const navigate = useNavigate();
//   const { oil_record_id } = useParams();
//   const user = useUserData();
//   const [loader, set_loader] = useState(false);
//   const [errors, set_errors] = useState({});
//   const [staff_dashboard, set_staff_dashboard] = useState("");
//   const [code, set_code] = useState("");
//   const [date, set_date] = useState(null);
//   const [signature, set_signature] = useState("");
//   const [free_Text, set_Free_Text] = useState("");
//   const [codeList, setCodeList] = useState([]);
//   const [codeItemList, setCodeItemList] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [submitStatus, setSubmitStatus] = useState(false);
//   const [initialDocument, setInitialDocument] = useState([]);
//   const [soft_delete, set_soft_delete] = useState(false);
//   const [reviewed_by_master, set_reviewed_by_master] = useState(false);
//   const [reviewed_by_chief, set_reviewed_by_chief] = useState(false);
//   const [isModalVisible, setModalVisible] = useState(false);
//   const [securitymodalVisible, setSecrityModalVisible] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [checked, setChecked] = useState(false);
//   const [child_id, set_child_id] = useState("");
//   const [previous_log_date, set_Previous_Log_Date] = useState("");
//   const { documentList, handleDocumentChange, getFilesForUpload } =
//     useDocumentUpload(initialDocument);
//   const [new_create_entry_status, set_new_create_entry_status] = useState("");
//   const [tankList, SetTankList] = useState([]);
//   const chief_master_reviewed = reviewed_by_chief && reviewed_by_master;
//   const [visible, setVisible] = useState(false);

//   let codes = 30;

//   const handleConfirm = async () => {
//     try {
//       await UPDATE_OIL_RECORD_LOGBOOK_APIS();
//       setVisible(false);
//     } finally {
//     }
//   };

//   const handleCancel = () => {
//     setVisible(false);
//   };

//   const LIST_OIL_RECORD_CODE_API = () => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRespones = res?.code_categories?.map((item) => {
//             return {
//               value: item?.id,
//               label: `(${item?.value}) ` + item?.label,
//             };
//           });
//           setCodeList(newRespones);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code list:", error);
//     }
//   };

//   const LIST_OIL_RECORD_ITEM_API = (code_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("code_category_id", code_id);
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRes = res?.subdetails?.map((item) => {
//             return {
//               value: item?.id,
//               label: item?.sub_code_name,
//               sub_code_name: item?.subdetails_child,
//             };
//           });

//           setCodeItemList(newRes);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code Item list:", error);
//     }
//   };

//   const handleCheckboxChange = (value) => {
//     setSelectedItems((prevItems) => {
//       const exists = prevItems.find((item) => item.id === value);
//       if (exists) {
//         return prevItems.filter((item) => item.id !== value);
//       } else {
//         return [...prevItems, { id: value, value: "" }];
//       }
//     });
//   };

//   const handleInputChange = (id, value, key = "value") => {
//     setSelectedItems((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
//     );
//   };

//   const groupedOptions = codeItemList.flatMap((item) => {
//     if (item.sub_code_name.length > 0) {
//       return {
//         label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
//         options: item.sub_code_name.map((sub, index) => ({
//           value: `${item.value}-${index}`,
//           label: ` ${sub?.subdetails_child}`,
//         })),
//       };
//     } else {
//       return {
//         value: item.value,
//         label: item.label,
//       };
//     }
//   });

//   const VIEW_OIL_RECORD_LOGBOOK_APIS = () => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("record_id", atob(oil_record_id));
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("request_type", "view");
//       post(ApiURL.view_update_orb_details_st, FORM_DATA).then((res) => {
//         if (res?.status === true) {
//           const oilRecordData = res?.data;
//           set_code(oilRecordData?.code_category);
//           set_date(oilRecordData?.date);
//           set_signature(oilRecordData?.operation_details);
//           set_Free_Text(oilRecordData?.comment);
//           setSubmitStatus(res?.submit_status);
//           setInitialDocument(oilRecordData?.files);
//           set_soft_delete(oilRecordData?.soft_delete);
//           set_reviewed_by_master(oilRecordData?.reviewed_by_master);
//           set_reviewed_by_chief(oilRecordData?.reviewed_by_chief_engineer);
//           set_child_id(res?.child_id);
//           set_Previous_Log_Date(res?.last_date);
//           set_new_create_entry_status(oilRecordData?.new_create_entry_status);
//           let parsedSubDetails = [];
//           const rawSubDetails = oilRecordData?.sub_detail_values;
//           if (Array.isArray(rawSubDetails)) {
//             parsedSubDetails = rawSubDetails;
//           } else if (
//             typeof rawSubDetails === "string" &&
//             rawSubDetails.trim() !== ""
//           ) {
//             try {
//               parsedSubDetails = JSON.parse(rawSubDetails);
//             } catch (e) {
//               console.error("Failed to parse sub_detail_values JSON:", e);
//             }
//           }
//           setSelectedItems(parsedSubDetails);
//         } else {
//           set_errors(res?.errors || {});
//         }
//       });
//     } catch (error) {
//       console.error("Error in VIEW_OIL_RECORD_LOGBOOK_APIS:", error);
//     }
//   };

//   const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("record_id", atob(record_id));
//       FORM_DATA.append(
//         "description",
//         "The Chief Engineer has completed the confirmation. Kindly review and confirm from your end as well."
//       );
//       const response = await post(ApiURL?.notification_save_req, FORM_DATA);
//       if (response?.status === true) {
//         SuccessToast(
//           "Congratulations!",
//           response?.message || "No message returned."
//         );
//       } else {
//         ErrorToast("Error", response?.message || "Something went wrong.");
//       }
//     } catch (error) {
//       ErrorToast(
//         "Request Failed",
//         "Could not complete the request. Please try again."
//       );
//     }
//   };

//   const UPDATE_OIL_RECORD_LOGBOOK_APIS = async (save_submit) => {
//     const files = getFilesForUpload();
//     set_loader(true);
//     if (
//       selectedItems?.some((item) => item.value === null || item.value === "")
//     ) {
//       alert("All checked input should be filled");
//       set_loader(false);
//       return;
//     }
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("save_submit", Number(save_submit) || 0);
//     FORM_DATA.append("record_id", atob(oil_record_id));
//     FORM_DATA.append("orb_part", "1");
//     FORM_DATA.append("code_category_id", code);
//     FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
//     FORM_DATA.append("date", date);
//     FORM_DATA.append("operation_details", signature);
//     FORM_DATA.append("comment", free_Text);
//     FORM_DATA.append("request_type", "edit");
//     files?.forEach((files) => {
//       FORM_DATA.append("files", files);
//     });
//     post(ApiURL.view_update_orb_details_st, FORM_DATA).then((res) => {
//       if (res?.status == true) {
//         if (!res?.child_id) {
//           SuccessToast(
//             "Congratulation!!",
//             "Update Oil Record Details Successfully Updated!!"
//           );
//           navigate("/list-oil-record-log-one");
//         }

//         set_loader(false);
//         if (oil_record_id) {
//           SEND_NOTIFICATION_CHIEF_ENGINEER(oil_record_id);
//         }
//       } else {
//         ErrorToast("Error message", res?.message);
//         const errors = res?.errors || {};
//         set_errors(errors);
//         set_loader(false);
//       }
//     });
//   };

//   useEffect(() => {
//     const staff_dashboards = localStorage.getItem("staff_dashboard");
//     const parsedData = JSON.parse(staff_dashboards);
//     set_staff_dashboard(parsedData);
//     VIEW_OIL_RECORD_LOGBOOK_APIS();
//     LIST_OIL_RECORD_CODE_API();
//     SHIP_TANKS_LIST_API();
//   }, []);

//   useEffect(() => {
//     if (code) {
//       LIST_OIL_RECORD_ITEM_API(code);
//     }
//   }, [code]);

//   const getDocUrl = (file) => {
//     if (file.url) return file.url;
//     if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
//     return null;
//   };

//   const handlePreviews = async (file) => {
//     const url = getDocUrl(file);
//     if (!url) {
//       message.error("No preview available for this file");
//       return;
//     }
//     window.open(url, "_blank");
//   };

//   const reomveItem = async (file) => {
//     const fileName = file.name;
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("file_name", fileName);
//     try {
//       post(ApiURL.remove_file_st, FORM_DATA).then((res) => {
//         if (res?.status === true) {
//           SuccessToast("Success", "File removed successfully");
//           VIEW_OIL_RECORD_LOGBOOK_APIS();
//         } else {
//           ErrorToast("Error", "Failed to remove file");
//           console.error("Failed to remove file:", res?.message);
//           return;
//         }
//       });
//     } catch (error) {
//       console.error("Error removing file:", error);
//       ErrorToast("Error", "Failed to remove file");
//       return;
//     }
//   };

//   const CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX = (record_id, chief_reviewed) => {
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("record_id", atob(record_id));
//     FORM_DATA.append("chief_reviewed", chief_reviewed);
//     FORM_DATA.append("orb_part", "1");
//     post(ApiURL.update_single_checkbox_st, FORM_DATA).then((res) => {
//       if (res?.status == true) {
//         SuccessToast("Success message !!", res?.message);
//         navigate("/list-oil-record-log-one");
//       } else {
//         ErrorToast("Error message", res?.message);
//       }
//     });
//   };

//   const SHIP_TANKS_LIST_API = async () => {
//     try {
//       const FORM_DATA = new FormData();
//       const staff_Details = JSON.parse(localStorage.getItem("user_data"));
//       FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
//       FORM_DATA.append("category_of_tank", "IOPP");
//       post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SetTankList(res?.tanks);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Sub Tanks list:", error);
//     }
//   };

//   useEffect(() => {
//     if (checked && oil_record_id) {
//       setOpen(true);
//     }
//   }, [checked, oil_record_id]);

//   const columns = [
//     { title: "ID", dataIndex: "id", key: "id", align: "center" },
//     {
//       title: "Tank Name",
//       dataIndex: "sub_tank_name",
//       key: "sub_tank_name",
//       align: "center",
//     },
//     {
//       title: "Max capacity",
//       dataIndex: "capacity",
//       key: "capacity",
//       align: "center",
//     },
//     {
//       title: "Tank Type",
//       dataIndex: "tank_type",
//       key: "tank_type",
//       align: "center",
//     },
//     {
//       title: "Category",
//       dataIndex: "category_name",
//       key: "category_name",
//       align: "center",
//     },
//     {
//       title: "Created Date",
//       dataIndex: "created_at",
//       align: "center",
//       key: "created_at",
//       render: (text, record) => <span>{formatDate(record?.created_at)}</span>,
//     },
//     {
//       title: "Updated Date",
//       dataIndex: "updated_at",
//       align: "center",
//       key: "updated_at",
//       render: (text, record) => <span>{formatDate(record?.updated_at)}</span>,
//     },
//   ];

//   return (
//     <>
//       <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
//       <div className="white-container">
//         <br />
//         <h3>Oil Record book Part 1 Information </h3>
//         <br />
//         <div className="row">
//           <div className="col-6">
//             <SelectInput
//               disabled={submitStatus || child_id}
//               label="Code"
//               value={code}
//               placeholder=" -- Selecte Code  -- "
//               style={{ width: "100%" }}
//               onChange={(value) => {
//                 set_code(value);
//                 setSelectedItems([]);
//                 LIST_OIL_RECORD_ITEM_API(value);
//               }}
//               options={codeList}
//               errors={errors?.code}
//             />
//           </div>
//           <div className="col-6">
//             <AppInput
//               disabled={submitStatus || child_id}
//               type="date"
//               label="Date"
//               placeholder="Date"
//               value={date}
//               onChange={(e) => set_date(e.target.value)}
//               errors={errors.date}
//               showInfo={code == 30}
//               infoMessage="Current Date - When the missed entry is being logged"
//               min={
//                 chief_master_reviewed
//                   ? new Date().toISOString().split("T")[0]
//                   : previous_log_date
//               }
//               max={new Date().toISOString().split("T")[0]}
//             />
//           </div>
//         </div>
//         {code == 30 && (
//           <div
//             className="row"
//             style={{ marginLeft: "5px", marginBottom: "7px" }}
//           >
//             <div style={{ marginRight: "5px" }}>
//               <label>
//                 Do you want to record a missed operation entry (Yes / No)
//               </label>
//             </div>
//             <Switch
//               value={checked}
//               onChange={(checked) => {
//                 setChecked(checked);
//               }}
//               checkedChildren="No"
//               unCheckedChildren="Yes"
//               style={{
//                 backgroundColor: checked ? "green" : "red",
//               }}
//             />
//           </div>
//         )}
//         {code && (
//           <div
//             className="col-12"
//             style={{
//               lineHeight: "2",
//               border: "1px solid #d9d9d9",
//               borderRadius: "5px",
//             }}
//           >
//             <strong className="form-label">Select Items:</strong>
//             {groupedOptions.map((optionGroup, index) => (
//               <div key={index} className="mb-3">
//                 {/* Main Label as Checkbox */}
//                 <div className="row align-items-center mb-2">
//                   <div className="col-6">
//                     <div className="form-check">
//                       {optionGroup?.options?.length > 1 ? (
//                         ""
//                       ) : (
//                         <input
//                           disabled={child_id}
//                           className="form-check-input"
//                           type="checkbox"
//                           value={optionGroup.label}
//                           checked={selectedItems.some(
//                             (item) => item.id === optionGroup.value
//                           )}
//                           onChange={() =>
//                             handleCheckboxChange(optionGroup.value)
//                           }
//                           id={`group-checkbox-${index}`}
//                         />
//                       )}
//                       <label
//                         className="form-check-label"
//                         htmlFor={`group-checkbox-${index}`}
//                       >
//                         {typeof optionGroup.label === "string" ? (
//                           <strong>{optionGroup.label}</strong>
//                         ) : (
//                           <strong>{optionGroup.label.props.children}</strong>
//                         )}
//                       </label>
//                     </div>
//                   </div>

//                   {/* Input Field for Main Label */}
//                   <div className="col-6" style={{ marginLeft: "22px" }}>
//                     {selectedItems.some(
//                       (item) => item.id === optionGroup.value
//                     ) && (
//                       <TextArea
//                         disabled={child_id}
//                         required
//                         maxLength={1000}
//                         className="form-control"
//                         autoSize={{ minRows: 1 }}
//                         placeholder={
//                           typeof optionGroup.label === "string"
//                             ? optionGroup.label
//                             : optionGroup.label.props.children
//                         }
//                         value={
//                           selectedItems.find(
//                             (item) => item.id === optionGroup.value
//                           )?.value || ""
//                         }
//                         onChange={(e) =>
//                           handleInputChange(optionGroup.value, e.target.value)
//                         }
//                       />
//                     )}
//                   </div>
//                   {/* Special Input - Only for 112 */}
//                   {Number(optionGroup.value) === 112 && (
//                     <div className="col-6" style={{ marginBottom: 20 }}>
//                       {selectedItems.some(
//                         (item) => Number(item.id) === 112
//                       ) && (
//                         <TextArea
//                           required
//                           maxLength={1000}
//                           className="form-control"
//                           autoSize={{ minRows: 2 }}
//                           placeholder="Discharged Volume"
//                           value={
//                             selectedItems.find(
//                               (item) => Number(item.id) === 112
//                             )?.dischargedvolume || ""
//                           }
//                           onChange={(e) =>
//                             handleInputChange(
//                               112,
//                               e.target.value,
//                               "dischargedvolume"
//                             )
//                           }
//                         />
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 {/* Sub-options */}
//                 {optionGroup.options && (
//                   <div
//                     className="ms-3"
//                     style={{ marginLeft: "30px", padding: "10px" }}
//                   >
//                     {optionGroup.options.map((option) => (
//                       <div
//                         key={option.value}
//                         className="row align-items-center mb-2"
//                       >
//                         {/* Left Side - Checkbox */}
//                         <div className="col-6">
//                           <div className="form-check">
//                             <input
//                               disabled={child_id}
//                               className="form-check-input"
//                               type="checkbox"
//                               value={option.value}
//                               checked={selectedItems.some(
//                                 (item) => item.id === option.value
//                               )}
//                               onChange={() =>
//                                 handleCheckboxChange(option.value)
//                               }
//                               id={`checkbox-${option.value}`}
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor={`checkbox-${option.value}`}
//                             >
//                               {option.label}
//                             </label>
//                           </div>
//                         </div>

//                         {/* Right Side - Input Field */}
//                         {/* <div className="col-6" style={{ padding: "5px" }}>
//                           {selectedItems.some(
//                             (item) => item.id === option.value
//                           ) && (
//                             <TextArea
//                               disabled={child_id}
//                               required
//                               maxLength={1000}
//                               className="form-control"
//                               autoSize={{ minRows: 2 }}
//                               placeholder={option.label}
//                               value={
//                                 selectedItems.find(
//                                   (item) => item.id === option.value
//                                 )?.value || ""
//                               }
//                               onChange={(e) =>
//                                 handleInputChange(option.value, e.target.value)
//                               }
//                             />
//                           )}
//                         </div> */}

//                         {/* Special case: two inputs only for id '111-3' and code '24' */}
//                         {option.value === "111-3" && (
//                           <div className="col-6" style={{ padding: "5px" }}>
//                             {selectedItems.some(
//                               (item) => item.id === option.value
//                             ) && (
//                               <TextArea
//                                 required
//                                 maxLength={1000}
//                                 className="form-control"
//                                 autoSize={{ minRows: 2 }}
//                                 placeholder={"Evaporation Volume"}
//                                 value={
//                                   selectedItems.find(
//                                     (item) => item.id === option.value
//                                   )?.evaporationVolume || "" // <- new JSON key
//                                 }
//                                 onChange={
//                                   (e) =>
//                                     handleInputChange(
//                                       option.value,
//                                       e.target.value,
//                                       "evaporationVolume"
//                                     ) // <- pass key name
//                                 }
//                               />
//                             )}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//         {errors?.sub_detail_values && (
//           <span style={{ color: "red" }}>{errors?.sub_detail_values}</span>
//         )}
//         <div className="row" style={{ paddingTop: "10px" }}>
//           <div className="col-6">
//             <AppInput
//               disabled={submitStatus || child_id}
//               label="Name of operation incharge"
//               placeholder="Name of operation incharge"
//               value={signature}
//               onChange={(e) => set_signature(e.target.value)}
//               errors={errors.signature}
//               showInfo={code == 30}
//               infoMessage="Officer making this entry now"
//             />
//           </div>
//           <div className="col-6">
//             <div
//               className="input-box"
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "8px",
//                 alignItems: "flex-start",
//               }}
//             >
//               <label>Select File</label>
//               <Upload
//                 accept=".pdf,.doc,.docx,.xls,.xlsx"
//                 multiple
//                 fileList={documentList}
//                 onChange={handleDocumentChange}
//                 onPreview={handlePreviews}
//                 beforeUpload={() => false}
//                 listType="picture"
//                 onRemove={reomveItem}
//               >
//                 <Button
//                   disabled={child_id}
//                   icon={<UploadOutlined />}
//                   type="primary"
//                   style={{
//                     borderRadius: "50%",
//                     padding: "10px",
//                     width: "40px",
//                     height: "40px",
//                     marginLeft: "10px",
//                   }}
//                 />
//               </Upload>
//             </div>
//           </div>
//         </div>

//         {!soft_delete &&
//           user?.data?.designation === "Chief Engineer" &&
//           oil_record_id && (
//             <div className="row">
//               <div className="input-box" style={{ marginTop: "15px" }}>
//                 <Button
//                   loading={loader}
//                   disabled={submitStatus}
//                   type="primary"
//                   className="save_btn"
//                   style={{ color: "white", marginLeft: "10px" }}
//                   // onClick={UPDATE_OIL_RECORD_LOGBOOK_APIS}
//                   onClick={() => setVisible(true)}
//                 >
//                   Save
//                 </Button>
//               </div>
//             </div>
//           )}
//         {!soft_delete &&
//           user?.data?.designation === "Captain" &&
//           oil_record_id && (
//             <div className="row">
//               <>
//                 <div
//                   className="input-box"
//                   style={{ marginLeft: "15px", marginTop: "15px" }}
//                 >
//                   <Button
//                     loading={loader}
//                     disabled={reviewed_by_master || !reviewed_by_chief}
//                     className="save_btn"
//                     style={{ color: "white" }}
//                     onClick={() => setSecrityModalVisible(true)}
//                   >
//                     Submit
//                   </Button>
//                 </div>
//                 <div
//                   className="input-box"
//                   style={{ marginLeft: "15px", marginTop: "15px" }}
//                 >
//                   <Button
//                     loading={loader}
//                     disabled={!reviewed_by_chief || reviewed_by_master}
//                     className="save_btn"
//                     style={{ color: "white" }}
//                     onClick={() => setModalVisible(!isModalVisible)}
//                   >
//                     Back to Edit
//                   </Button>
//                 </div>
//               </>
//             </div>
//           )}
//       </div>
//       <div className="white-container">
//         <Table
//           bordered
//           columns={columns}
//           dataSource={tankList}
//           pagination={{ pageSize: 10 }}
//           rowKey="key"
//           className="custom-table"
//         />
//       </div>
//       <RequestFormModal
//         visible={isModalVisible}
//         record_id={atob(oil_record_id)}
//         voyage_ids={staff_dashboard?.voyage_details?.[0]?.id}
//         setModalVisible={setModalVisible}
//         onCancel={() => {
//           setModalVisible(!isModalVisible);
//         }}
//         routing={"/list-oil-record-log-one"}
//         backtoedit={"backtoedit"}
//         designation={"captain"}
//       />
//       <SecurityCodeModal
//         record_id={atob(oil_record_id)}
//         visible={securitymodalVisible}
//         setModalVisible={setModalVisible}
//         onCancel={() => setSecrityModalVisible(false)}
//         onSuccess={() => {
//           CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(oil_record_id, 1);
//           setModalVisible(false);
//         }}
//         apiEndPoint={ApiURL.verify_security_code_st}
//       />
//       <EditOilRecordLogPartOneModal
//         visible={open}
//         onClose={() => setOpen(false)}
//         onSuccess={() => {}}
//         child_id={child_id}
//         oil_record_id={oil_record_id}
//       />
//       <ConfirmationModal
//         visible={visible}
//         message="Please verify all entries before submitting."
//         loading={loader}
//         onOk={handleConfirm}
//         onCancel={handleCancel}
//       />
//     </>
//   );
// }

// export default EditOilRecordLogOne;



import { Button, message, Switch, Table, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppInput from "../../../components/AppInput";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import VoyageDetails from "../../../components/VoyageDetails";
import useUserData from "../../../hooks/useUserData";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import TextArea from "antd/es/input/TextArea";
import RequestFormModal from "../../../components/RequestFormModal.js";
import SecurityCodeModal from "../../../components/SecurityCodeModal.js";
import EditOilRecordLogPartOneModal from "./components/IcodeEditEntry.js";
import { formatDate } from "../../../utils/dateFormatter.js";
import ConfirmationModal from "../../../components/ConfirmationDialog.js";
import OrbPart1StructuredForm from "./components/OrbPart1StructuredForm";
import "./orbPart1Add.css";
import PdfPreviewModal from "../../common/pdfreviewbutton";

function EditOilRecordLogOne() {
  const navigate = useNavigate();
  const { oil_record_id } = useParams();
  const user = useUserData();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState("");
  const [code, set_code] = useState("");
  const [date, set_date] = useState(null);
  const [signature, set_signature] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [initialDocument, setInitialDocument] = useState([]);
  const [soft_delete, set_soft_delete] = useState(false);
  const [reviewed_by_master, set_reviewed_by_master] = useState(false);
  const [reviewed_by_chief, set_reviewed_by_chief] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const [securitymodalVisible, setSecrityModalVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [child_id, set_child_id] = useState("");
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload(initialDocument);
  const [new_create_entry_status, set_new_create_entry_status] = useState("");
  const [tankList, SetTankList] = useState([]);
  const chief_master_reviewed = reviewed_by_chief && reviewed_by_master;
  const [visible, setVisible] = useState(false);
  const [operationKey, setOperationKey] = useState("");
  const [enhancedInitialValue, setEnhancedInitialValue] = useState(null);
  const [enhancedEntry, setEnhancedEntry] = useState(null);

  let codes = 30;

  const handleConfirm = async () => {
    try {
      await UPDATE_OIL_RECORD_LOGBOOK_APIS();
      setVisible(false);
    } finally {
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const LIST_OIL_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.code_categories?.map((item) => {
            return {
              value: item?.id,
              label: `(${item?.value}) ` + item?.label,
              code: item?.value,
            };
          });
          setCodeList(newRespones);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code_category_id", code_id);
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.subdetails?.map((item) => {
            return {
              value: item?.id,
              label: item?.sub_code_name,
              sub_code_name: item?.subdetails_child,
            };
          });

          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      if (exists) {
        return prevItems.filter((item) => item.id !== value);
      } else {
        return [...prevItems, { id: value, value: "" }];
      }
    });
  };

  const handleInputChange = (id, value, key = "value") => {
    setSelectedItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    );
  };

   const handleSpecialInputChange = (id, value, key = "specialValue") => {
  if (!/^[0-9A-Za-z.\s]*$/.test(value)) return; // Only allow alphanumeric + dot
  if (value.startsWith(".")) return; // No dot as first char
  if (value.length === 1 && !/^[0-9]$/.test(value)) return; // Must start with number
  if ((value.match(/\./g) || []).length > 1) return; // Only one dot allowed

  set_errors((prev) => ({ ...prev, [key]: "" }));

  setSelectedItems((prev) =>
    prev.map((item) =>
      item.id === id
        ? {
            ...item,
            [key]: value.toUpperCase(), 
            value: value.toUpperCase(), 
          }
        : item
    )
  );
};


  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  

  const VIEW_OIL_RECORD_LOGBOOK_APIS = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("record_id", atob(oil_record_id));
      FORM_DATA.append("orb_part", "1");
      FORM_DATA.append("request_type", "view");
      post(ApiURL.view_update_orb_details_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const oilRecordData = res?.data;
          set_code(oilRecordData?.code_category);
          set_date(oilRecordData?.date);
          set_signature(oilRecordData?.operation_details);
          set_Free_Text(oilRecordData?.comment);
          setSubmitStatus(res?.submit_status);
          setInitialDocument(oilRecordData?.files);
          set_soft_delete(oilRecordData?.soft_delete);
          set_reviewed_by_master(oilRecordData?.reviewed_by_master);
          set_reviewed_by_chief(oilRecordData?.reviewed_by_chief_engineer);
          set_child_id(res?.child_id);
          set_Previous_Log_Date(res?.last_date);
          set_new_create_entry_status(oilRecordData?.new_create_entry_status);
          const persistedOperationKey = oilRecordData?.operation_key || "";
          setOperationKey(persistedOperationKey);
          setEnhancedInitialValue(persistedOperationKey ? {
            operationKey: persistedOperationKey,
            data: oilRecordData?.structured_data || {},
            officerId: oilRecordData?.operation_in_charge_id || "",
            preview: oilRecordData?.rendered_lines || [],
          } : null);
          let parsedSubDetails = [];
          const rawSubDetails = oilRecordData?.sub_detail_values;
          if (Array.isArray(rawSubDetails)) {
            parsedSubDetails = rawSubDetails;
          } else if (
            typeof rawSubDetails === "string" &&
            rawSubDetails.trim() !== ""
          ) {
            try {
              parsedSubDetails = JSON.parse(rawSubDetails);
            } catch (e) {
              console.error("Failed to parse sub_detail_values JSON:", e);
            }
          }
          setSelectedItems(parsedSubDetails);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error in VIEW_OIL_RECORD_LOGBOOK_APIS:", error);
    }
  };

  const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("orb_part", "1");
      FORM_DATA.append("record_id", atob(record_id));
      FORM_DATA.append(
        "description",
        "The Chief Engineer has completed the confirmation. Kindly review and confirm from your end as well."
      );
      const response = await post(ApiURL?.notification_save_req, FORM_DATA);
      if (response?.status === true) {
        SuccessToast(
          "Congratulations!",
          response?.message || "No message returned."
        );
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast(
        "Request Failed",
        "Could not complete the request. Please try again."
      );
    }
  };

  const UPDATE_OIL_RECORD_LOGBOOK_APIS = async (save_submit) => {
    const files = getFilesForUpload();
    set_loader(true);
    if (
      selectedItems?.some((item) => item.value === null || item.value === "")
    ) {
      alert("All checked input should be filled");
      set_loader(false);
      return;
    }
    const FORM_DATA = new FormData();
    FORM_DATA.append("save_submit", Number(save_submit) || 0);
    FORM_DATA.append("record_id", atob(oil_record_id));
    FORM_DATA.append("orb_part", "1");
    FORM_DATA.append("code_category_id", code);
    FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
    FORM_DATA.append("date", date);
    FORM_DATA.append("operation_details", signature);
    FORM_DATA.append("comment", free_Text);
    FORM_DATA.append("request_type", "edit");
    if (operationKey && enhancedEntry) {
      FORM_DATA.append("operation_key", enhancedEntry.operationKey);
      FORM_DATA.append("structured_data", JSON.stringify(enhancedEntry.data));
      FORM_DATA.append("operation_in_charge_id", enhancedEntry.officerId);
    }
    files?.forEach((files) => {
      FORM_DATA.append("files", files);
    });
    post(ApiURL.view_update_orb_details_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        if (!res?.child_id) {
          SuccessToast(
            "Congratulation!!",
            "Update Oil Record Details Successfully Updated!!"
          );
          navigate("/list-oil-record-log-one");
        }

        set_loader(false);
        if (oil_record_id) {
          SEND_NOTIFICATION_CHIEF_ENGINEER(oil_record_id);
        }
      } else {
        ErrorToast("Error message", res?.message);
        const errors = res?.errors || {};
        set_errors(errors);
        set_loader(false);
      }
    });
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_OIL_RECORD_LOGBOOK_APIS();
    LIST_OIL_RECORD_CODE_API();
    SHIP_TANKS_LIST_API();
  }, []);

  useEffect(() => {
    if (code) {
      LIST_OIL_RECORD_ITEM_API(code);
    }
  }, [code]);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const reomveItem = async (file) => {
    const fileName = file.name;
    const FORM_DATA = new FormData();
    FORM_DATA.append("file_name", fileName);
    try {
      post(ApiURL.remove_file_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", "File removed successfully");
          VIEW_OIL_RECORD_LOGBOOK_APIS();
        } else {
          ErrorToast("Error", "Failed to remove file");
          console.error("Failed to remove file:", res?.message);
          return;
        }
      });
    } catch (error) {
      console.error("Error removing file:", error);
      ErrorToast("Error", "Failed to remove file");
      return;
    }
  };

  const CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX = (record_id, chief_reviewed) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", atob(record_id));
    FORM_DATA.append("chief_reviewed", chief_reviewed);
    FORM_DATA.append("orb_part", "1");
    post(ApiURL.update_single_checkbox_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        navigate("/list-oil-record-log-one");
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  const SHIP_TANKS_LIST_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("category_of_tank", "IOPP");
      post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SetTankList(res?.tanks);
        }
      });
    } catch (error) {
      console.error("Error fetching Sub Tanks list:", error);
    }
  };

  useEffect(() => {
    if (checked && oil_record_id) {
      setOpen(true);
    }
  }, [checked, oil_record_id]);



  const columns = [
    { title: "ID", dataIndex: "id", key: "id", align: "center" },
    {
      title: "Tank Name",
      dataIndex: "sub_tank_name",
      key: "sub_tank_name",
      align: "center",
    },
    {
      title: "Max capacity",
      dataIndex: "capacity",
      key: "capacity",
      align: "center",
    },
    {
      title: "Tank Type",
      dataIndex: "tank_type",
      key: "tank_type",
      align: "center",
    },
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      align: "center",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => <span>{formatDate(record?.created_at)}</span>,
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => <span>{formatDate(record?.updated_at)}</span>,
    },
  ];

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container orb-add-page">
        <header className="orb-page-header">
          <div><div className="orb-page-eyebrow">Statutory logbook · Edit entry</div><h3>Oil Record Book — Part I</h3><p>Machinery-space operations (all ships)</p></div>
          <PdfPreviewModal pdfFileName="ORB-PART-1.pdf" />
        </header>
        <section className="orb-entry-context">
          <div className="orb-context-field">
            <SelectInput
              disabled={submitStatus || child_id}
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
                LIST_OIL_RECORD_ITEM_API(value);
              }}
              options={codeList}
              errors={errors?.code}
            />
          </div>
          <div className="orb-context-field">
            <AppInput
              disabled={submitStatus || child_id}
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
              showInfo={code == 30}
              infoMessage="Current Date - When the missed entry is being logged"
              min={
                chief_master_reviewed
                  ? new Date().toISOString().split("T")[0]
                  : previous_log_date
              }
              max={new Date().toISOString().split("T")[0]}
            />
          </div>
        </section>
        {code == 30 && (
          <div
            className="row"
            style={{ marginLeft: "5px", marginBottom: "7px" }}
          >
            <div style={{ marginRight: "5px" }}>
              <label>
                Do you want to record a missed operation entry (Yes / No)
              </label>
            </div>
            <Switch
              value={checked}
              onChange={(checked) => {
                setChecked(checked);
              }}
              checkedChildren="No"
              unCheckedChildren="Yes"
              style={{
                backgroundColor: checked ? "green" : "red",
              }}
            />
          </div>
        )}
        {operationKey && enhancedInitialValue && (
          <OrbPart1StructuredForm
            codeLetter={codeList.find((item) => String(item.value) === String(code))?.code}
            entryDate={date}
            filesCount={getFilesForUpload()?.length || 0}
            initialValue={enhancedInitialValue}
            onChange={setEnhancedEntry}
            readOnly={Boolean(submitStatus || child_id)}
          />
        )}
        {!operationKey && code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "5px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {groupedOptions.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                {/* Main Label as Checkbox */}
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      {optionGroup?.options?.length > 1 ? (
                        ""
                      ) : (
                        <input
                          disabled={child_id}
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some(
                            (item) => item.id === optionGroup.value
                          )}
                          onChange={() =>
                            handleCheckboxChange(optionGroup.value)
                          }
                          id={`group-checkbox-${index}`}
                        />
                      )}
                      <label
                        className="form-check-label"
                        htmlFor={`group-checkbox-${index}`}
                      >
                        {typeof optionGroup.label === "string" ? (
                          <strong>{optionGroup.label}</strong>
                        ) : (
                          <strong>{optionGroup.label.props.children}</strong>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* Input Field for Main Label */}
                    <div className="col-6" style={{ marginLeft: "22px" }}>
                      {selectedItems.some(
                        (item) => item.id === optionGroup.value
                      ) && (
                        Number(optionGroup.value) === 112 ?  <>
                       <TextArea
                        required
                        maxLength={1000}
                        className={`form-control ${
                          errors?.specialInput ? "border border-danger" : ""
                        }`}
                        autoSize={{ minRows: 2 }}
                        // placeholder="Enter value like 1.23A"
                         placeholder="Always start the sentence in Item 13 with the total quantity discharged. Our system will only look at that first number for our records."
                        value={
                          selectedItems.find((item) => item.id === optionGroup.value)
                            ?.specialValue || ""
                        }
                        onChange={(e) =>
                          handleSpecialInputChange(optionGroup.value, e.target.value)
                        }
                      />
                      {errors?.specialInput && (
                        <p style={{ color: "red", marginTop: "4px" }}>
                          {errors.specialInput}
                        </p>
                      )}
                    </>:
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder={
                            typeof optionGroup.label === "string"
                              ? optionGroup.label
                              : optionGroup.label.props.children
                          }
                          value={
                            selectedItems.find(
                              (item) => item.id === optionGroup.value
                            )?.value || ""
                          }
                          onChange={(e) =>
                            handleInputChange(optionGroup.value, e.target.value)
                          }
                        />
                      )}
                    </div>

                  {/* Special Input - Only for 112 */}
                  {/* {Number(optionGroup.value) === 112 && (
                    <div className="col-6" style={{ marginBottom: 20 }}>
                      {selectedItems.some(
                        (item) => Number(item.id) === 112
                      ) && (
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder="Discharged Volume"
                          value={
                            selectedItems.find(
                              (item) => Number(item.id) === 112
                            )?.dischargedvolume || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              112,
                              e.target.value,
                              "dischargedvolume"
                            )
                          }
                        />
                      )}
                    </div>
                  )} */}
                </div>

                {/* Sub-options */}
                {optionGroup.options && (
                  <div
                    className="ms-3"
                    style={{ marginLeft: "30px", padding: "10px" }}
                  >
                    {optionGroup.options.map((option) => (
                      <div
                        key={option.value}
                        className="row align-items-center mb-2"
                      >
                        {/* Left Side - Checkbox */}
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              disabled={child_id}
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              checked={selectedItems.some(
                                (item) => item.id === option.value
                              )}
                              onChange={() =>
                                handleCheckboxChange(option.value)
                              }
                              id={`checkbox-${option.value}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>

                        {/* Right Side - Input Field */}
                        {/* <div className="col-6" style={{ padding: "5px" }}>
                          {selectedItems.some(
                            (item) => item.id === option.value
                          ) && (
                            <TextArea
                              disabled={child_id}
                              required
                              maxLength={1000}
                              className="form-control"
                              autoSize={{ minRows: 2 }}
                              placeholder={option.label}
                              value={
                                selectedItems.find(
                                  (item) => item.id === option.value
                                )?.value || ""
                              }
                              onChange={(e) =>
                                handleInputChange(option.value, e.target.value)
                              }
                            />
                          )}
                        </div> */}

                        {/* Special case: two inputs only for id '111-3' and code '24' */}
                        {/* {option.value === "111-3" && (
                          <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some(
                              (item) => item.id === option.value
                            ) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 2 }}
                                placeholder={"Evaporation Volume"}
                                value={
                                  selectedItems.find(
                                    (item) => item.id === option.value
                                  )?.evaporationVolume || "" // <- new JSON key
                                }
                                onChange={
                                  (e) =>
                                    handleInputChange(
                                      option.value,
                                      e.target.value,
                                      "evaporationVolume"
                                    ) // <- pass key name
                                }
                              />
                            )}
                          </div>
                        )} */}
                        <div className="col-6" style={{ padding: "5px" }}>
  {selectedItems.some((item) => item.id === option.value) && (
    <>
      {/* Special case: only show this special input when id=111-3 & code=24 */}
      {option.value === "111-3" && code === 24 ? (
        <>
          <TextArea
            required
            maxLength={1000}
            className={`form-control ${
              errors?.specialInput ? "border border-danger" : ""
            }`}
            autoSize={{ minRows: 2 }}
             placeholder="Always start the sentence in Item 12.4 with the total quantity evaporated. Our system will only look at that first number for our records."
            value={
              selectedItems.find((item) => item.id === option.value)
                ?.specialValue || ""
            }
            onChange={(e) =>
              handleSpecialInputChange(option.value, e.target.value)
            }
          />
          {errors?.specialInput && (
            <p style={{ color: "red", marginTop: "4px" }}>
              {errors.specialInput}
            </p>
          )}
        </>
      ) : (
        <TextArea
          required
          maxLength={1000}
          className="form-control"
          autoSize={{ minRows: 2 }}
          placeholder={option.label}
          value={
            selectedItems.find((item) => item.id === option.value)?.value || ""
          }
          onChange={(e) => handleInputChange(option.value, e.target.value)}
        />
      )}
    </>
  )}
                      </div>

                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {errors?.sub_detail_values && (
          <span style={{ color: "red" }}>{errors?.sub_detail_values}</span>
        )}
        {!operationKey && <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-6">
            <AppInput
              disabled={submitStatus || child_id}
              label="Name of operation incharge"
              placeholder="Name of operation incharge"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.signature}
              showInfo={code == 30}
              infoMessage="Officer making this entry now"
            />
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                onRemove={reomveItem}
              >
                <Button
                  disabled={child_id}
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                />
              </Upload>
            </div>
          </div>
        </div>}

        {!soft_delete &&
          user?.data?.designation === "Chief Engineer" &&
          oil_record_id && (
            <div className="row">
              <div className="input-box" style={{ marginTop: "15px" }}>
                <Button
                  loading={loader}
                  disabled={submitStatus}
                  type="primary"
                  className="save_btn"
                  style={{ color: "white", marginLeft: "10px" }}
                  // onClick={UPDATE_OIL_RECORD_LOGBOOK_APIS}
                  onClick={() => setVisible(true)}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        {!soft_delete &&
          user?.data?.designation === "Captain" &&
          oil_record_id && (
            <div className="row">
              <>
                <div
                  className="input-box"
                  style={{ marginLeft: "15px", marginTop: "15px" }}
                >
                  <Button
                    loading={loader}
                    disabled={reviewed_by_master || !reviewed_by_chief}
                    className="save_btn"
                    style={{ color: "white" }}
                    onClick={() => setSecrityModalVisible(true)}
                  >
                    Submit
                  </Button>
                </div>
                <div
                  className="input-box"
                  style={{ marginLeft: "15px", marginTop: "15px" }}
                >
                  <Button
                    loading={loader}
                    disabled={!reviewed_by_chief || reviewed_by_master}
                    className="save_btn"
                    style={{ color: "white" }}
                    onClick={() => setModalVisible(!isModalVisible)}
                  >
                    Back to Edit
                  </Button>
                </div>
              </>
            </div>
          )}
      </div>
      <div className="white-container">
        <Table
          bordered
          columns={columns}
          dataSource={tankList}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          className="custom-table"
        />
      </div>
      <RequestFormModal
        visible={isModalVisible}
        record_id={atob(oil_record_id)}
        voyage_ids={staff_dashboard?.voyage_details?.[0]?.id}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
        routing={"/list-oil-record-log-one"}
        backtoedit={"backtoedit"}
        designation={"captain"}
      />
      <SecurityCodeModal
        record_id={atob(oil_record_id)}
        visible={securitymodalVisible}
        setModalVisible={setModalVisible}
        onCancel={() => setSecrityModalVisible(false)}
        onSuccess={() => {
          CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(oil_record_id, 1);
          setModalVisible(false);
        }}
        apiEndPoint={ApiURL.verify_security_code_st}
      />
      <EditOilRecordLogPartOneModal
        visible={open}
        onClose={() => setOpen(false)}
        onSuccess={() => {}}
        child_id={child_id}
        oil_record_id={oil_record_id}
      />
      <ConfirmationModal
        visible={visible}
        message="Please verify all entries before submitting."
        loading={loader}
        onOk={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}

export default EditOilRecordLogOne;




